/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Section_Sreality_Attrs_HintInputs */

const cs_property_section_sreality_attrs_hint = /** @type {(inputs: Property_Section_Sreality_Attrs_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volitelná pole z katalogu Sreality pro tento typ nemovitosti.`)
};

const en_property_section_sreality_attrs_hint = /** @type {(inputs: Property_Section_Sreality_Attrs_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional portal fields from the Sreality catalog for this property type.`)
};

/**
* | output |
* | --- |
* | "Optional portal fields from the Sreality catalog for this property type." |
*
* @param {Property_Section_Sreality_Attrs_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_section_sreality_attrs_hint = /** @type {((inputs?: Property_Section_Sreality_Attrs_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Section_Sreality_Attrs_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_section_sreality_attrs_hint(inputs)
	return cs_property_section_sreality_attrs_hint(inputs)
});